import { AmplifyGet } from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import type {
  PromotionSelectionApiResponse,
  PromotionSelectionItem,
} from "../../amplify/backend/function/offerexpstoreFrontApi/ts/public/promotionTypes";
import { logger } from "providers/logger";

const getRepAppliedPromotions = async (
  authKey: string,
  prospectId: string,
  proposalId: string,
  promotionType: string
): Promise<PromotionSelectionItem[]> => {
  const response = await AmplifyGet<PromotionSelectionApiResponse>(
    "Get Promotions",
    "OfferExpApi",
    `/offers/prospect/${prospectId}/promotions?proposalName=${proposalId}&promotionType=${promotionType}`,
    {
      headers: {
        Authorization: `Bearer ${authKey}`,
      },
    },
    logger
  );
  return (response.promotions ?? []).map((item) => item.wrapRec);
};

const getCustomerAppliedPromotions = async (
  authKey: string,
  proposalId: string,
  prospectId: string,
  promotionType: string
): Promise<PromotionSelectionItem[]> => {
  const response = await AmplifyGet<PromotionSelectionApiResponse>(
    "Get Customer Promotions",
    "OfferExpApi",
    `/customer/${authKey}/promotions?proposalName=${proposalId}&prospectId=${prospectId}&promotionType=${promotionType}`,
    {
      headers: {
        Authorization: `Bearer ${authKey}`,
      },
    },
    logger
  );
  return (response.promotions ?? []).map((item) => item.wrapRec);
};

export {
  type PromotionSelectionItem,
  getRepAppliedPromotions,
  getCustomerAppliedPromotions,
};
